





import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "PaymentSystemLogo",
  props: {
    src: { type: String, required: true },
  },
});
